<ion-header>
  <ion-toolbar>
    @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }@else{
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
    <ion-title>
      @switch (report.type) { @case (ConstructionDayReportType.$0) {
      Bautagesbericht } @case (ConstructionDayReportType.$1) { Fahrtenbericht }
      @case (ConstructionDayReportType.$2) { Arbeitszeitbericht } @default {
      Bericht } }{{ this.toolService.formatDt(report?.date) }}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="same-day-reports" *ngIf="sameDayReports.length > 1">
    Es wurden {{ sameDayReports.length }} Berichte für dieses Datum für diese
    Baustelle gefunden. Klicke den Bauführer für den entsprechenden Bericht an.
  </div>
  <ion-segment
    style="width: 100%"
    [value]="paramId"
    *ngIf="sameDayReports.length > 1"
    (ionChange)="segmentChanged($event)"
  >
    <ion-segment-button *ngFor="let rp of sameDayReports" [value]="rp.id">
      <ion-label>{{
        state.getUserDisplayNameAsync(rp.responsibleWorker) | async
      }}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <div class="container">
    <div>
      <div class="stretch">
        @if(report.type === ConstructionDayReportType.$0){
        <ion-chip color="primary">
          <ion-icon name="clipboard-outline"></ion-icon>
          <ion-label color="dark">Bautagesbericht</ion-label>
        </ion-chip>

        } @if(report.type === ConstructionDayReportType.$1){
        <ion-chip color="primary">
          <ion-icon name="speedometer-outline"></ion-icon>
          <ion-label color="dark">Fahrtenbericht</ion-label>
        </ion-chip>

        } @if(report.type === ConstructionDayReportType.$2){
        <ion-chip color="primary">
          <ion-icon name="time-outline"></ion-icon>
          <ion-label color="dark">Arbeitszeitbericht</ion-label>
        </ion-chip>

        } @if(report.isDraft){
        <ion-chip color="primary">
          <ion-icon name="document-text-outline"></ion-icon>
          <ion-label color="dark">Entwurf</ion-label>
        </ion-chip>
        } @if(!report.isDraft && report.approvedBy == null){
        <ion-chip color="warning">
          <ion-icon color="warning" name="checkmark-circle-outline"></ion-icon>
          <ion-label color="dark">In Bearbeitung</ion-label>
        </ion-chip>
        } @if(report.approvedBy != null){
        <ion-chip color="success">
          <ion-icon color="success" name="checkmark-circle-outline"></ion-icon>
          <ion-label color="dark">Bestätigt</ion-label>
        </ion-chip>
        }
      </div>

      <div class="stretch" *ngIf="state.userHasMinType(3)">
        <div>Id:</div>
        <div>
          {{ report.id }}
        </div>
      </div>
      <div class="stretch">
        <div>Baustelle:</div>
        <div>
          {{ state.getConstructionSiteName(report.constructionSite) }}
        </div>
      </div>
      <div class="stretch">
        <div>
          @if(report.type == ConstructionDayReportType.$1){
          Fahrer}@else{Verantwortlicher Bauführer}:
        </div>
        <div>
          {{ state.getUserDisplayNameAsync(report.responsibleWorker) | async }}
        </div>
      </div>
      @if(report.type == ConstructionDayReportType.$0){
      <div class="stretch">
        <div>Witterung:</div>
        <div>
          @if(report.weather?.length > 0){
          <span>{{ report.weather.join(", ") }} / </span>
          }
          {{ report.temperatureInCelsius }}°C
        </div>
      </div>
      }
      <div class="stretch" *ngIf="report.electricityUsedInKWH > 0">
        <div>Baustrom:</div>
        <div>{{ report.electricityUsedInKWH }} kWh</div>
      </div>
      <div class="stretch" *ngIf="report.waterUsedInCubicMeters">
        <div>Bauwasser:</div>
        <div>{{ report.waterUsedInCubicMeters }} m³</div>
      </div>
      <div class="stretch" *ngIf="report.workers.length > 0">
        <div>Beschäftigte Mitarbeiter:</div>
        <div>{{ report.workers.length }}</div>
      </div>
      <div class="stretch" *ngIf="report.lastModifiedUtc">
        <div>Zuletzt bearbeitet:</div>
        <div>
          {{ state.getUserDisplayNameAsync(report.lastModifiedBy) | async }} ({{
            this.toolService.formatDt(report.lastModifiedUtc)
          }}, {{ this.toolService.formatTime(report.lastModifiedUtc, true) }})
        </div>
      </div>
      <div
        style="border-top: 1px solid black; padding-top: 10px; margin-top: 10px"
      ></div>
      <div *ngIf="report.workingTimes">
        <b
          >Arbeitszeit ({{
            this.toolService.calculateHours(this.report.workingTimes)
          }})</b
        >
      </div>
      <div *ngIf="report.workingTimes">
        <div *ngFor="let time of report.workingTimes">
          {{ this.toolService.formatTime(time.start) }} bis
          {{ this.toolService.formatTime(time.end) }}
        </div>
      </div>
      <div *ngFor="let worker of report.workers">
        <b
          >{{ this.state.getUserDisplayNameAsync(worker) | async }} ({{
            this.toolService.calculateHours(
              this.report.workerTimeEntries[worker]
            )
          }})</b
        >
        <div *ngFor="let time of report.workerTimeEntries[worker]">
          {{ this.toolService.formatTime(time.start) }} bis
          {{ this.toolService.formatTime(time.end) }}
        </div>
      </div>
      <div
        style="border-top: 1px solid black; padding-top: 10px; margin-top: 10px"
      ></div>
      <div *ngIf="report.report">
        <div>
          <b>Leistungsergebnisse</b>
        </div>
        <div class="multiline">{{ report.report }}</div>
      </div>
      <div *ngIf="report.rapport">
        <div><b>Rapport / Taglohnarbeiten</b></div>
        <div>{{ report.rapport }}</div>
      </div>
      <div *ngIf="report.difficulties">
        <div><b>Behinderungen / Erschwernisse</b></div>
        <div>{{ report.difficulties }}</div>
      </div>
      <div *ngIf="report.specialIncidents">
        <div><b>Besondere Vorkommnisse</b></div>
        <div>{{ report.specialIncidents }}</div>
      </div>
      @if(report.machineUsages?.length > 0){
      <div
        style="border-top: 1px solid black; padding-top: 10px; margin-top: 10px"
      ></div>
      <div><b>Maschinennutzung</b></div>
      @for(machine of report.machineUsages; track machine){
      <div>{{ state.getMachineNameAsync(machine.id) | async }}</div>
      <div>
        @if(machine.usageInHours){{{machine.usageInHours}}
        Stunden}@if(machine.usageInDays){{{machine.usageInDays}} Tage}
      </div>
      <div>{{ machine.description }}</div>
      <br />
      } } @if(attachedImageNodeItems.length > 0){
      <div
        style="border-top: 1px solid black; padding-top: 10px; margin-top: 10px"
      ></div>

      <b>Bilder:</b>

      <div class="preview-container">
        <div
          class="preview-card"
          *ngFor="let preview of previews"
          (click)="state.openFile(preview.id, 'document', true)"
        >
          <!-- Lädt -->
          <ng-container *ngIf="preview.loading">
            <div class="loading-container">
              <ion-spinner name="crescent"></ion-spinner>
            </div>
          </ng-container>

          <!-- Fehler -->
          <ng-container *ngIf="!preview.loading && preview.hasError">
            <div class="error-container">
              <ion-icon name="image-outline" color="medium"> </ion-icon>
            </div>
          </ng-container>

          <!-- Bild -->
          <img
            *ngIf="!preview.loading && !preview.hasError"
            [src]="preview.imageUrl"
            alt="Preview"
          />
        </div>
      </div>
      } @if(attachedDocumentNodeItems.length > 0){
      <div
        style="border-top: 1px solid black; padding-top: 10px; margin-top: 10px"
      ></div>

      <b>Dokumente:</b>
      @for(doc of attachedDocumentNodeItems; track doc.id){
      <div class="base-padding">
        <ion-button
          fill="outline"
          (click)="state.openFile(doc.id, 'document', true)"
          style="width: 100%"
        >
          <ion-icon slot="start" [name]="state.getIcon(doc)"></ion-icon>
          {{ doc.displayName }}
        </ion-button>
      </div>
      } }
      <div *ngIf="report.errors?.length > 0" style="padding-top: 6px">
        Fehlerliste:
        <ul>
          <li *ngFor="let err of report.errors">
            {{ err }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="footer-buttons">
      <ion-button
        *ngIf="
          report.errors?.length > 0 &&
          report.approvedBy == null &&
          state.userHasMinType(1)
        "
        (click)="fixErrors()"
        >Fehler beheben</ion-button
      >
      <ion-button (click)="viewReport()">Anzeigen</ion-button>

      @if( state.userHasMinType(2) || (report.approvedBy == null &&
      state.userHasMinType(1)) || (report.isDraft && state.userName ==
      report.responsibleWorker) || (report.isDraft && state.userName ==
      report.responsibleWorker) || (report.approvedBy == null && isFreshReport)
      ){
      <ion-button (click)="editReport()">Bearbeiten</ion-button>}
      <ion-button
        color="success"
        (click)="approveReport()"
        *ngIf="
          state.userHasMinType(1) &&
          report.approvedBy == null &&
          !report.isDraft &&
          report.errors?.length == 0
        "
        >Bestätigen</ion-button
      >
      @if(state.userHasMinType(2) || (report.isDraft && (state.userHasMinType(1)
      || state.userName == report.responsibleWorker ))){
      <ion-button color="danger" (click)="deleteReport()">Löschen</ion-button>}
    </div>
  </ion-toolbar>
</ion-footer>
